<template>
  <v-container>
    <v-row justify="center">
      <v-col>
        <v-dialog v-model="confirm.show" persistent max-width="400">
          <v-snackbar
            v-model="confirm.show"
            :multi-line="true"
            centered
            :timeout="null"
          >
            <v-alert outlined type="warning">
              {{ title() }}
            </v-alert>
            <br />
            {{ confirm.content }}

            <br />

            <v-btn
              v-for="(button, buttonIndex) in buttons()"
              :key="buttonIndex"
              color="grey"
              text
              @click="(e) => buttonClick(button, e)"
            >
              {{ button.caption }}
            </v-btn>
          </v-snackbar>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Confirm",
  props: ["confirm", "generalExApplicationEx"],
  data() {
    return {};
  },
  methods: {
    title() {
      return this.translatedText("dialogConfirmation");
    },

    buttons() {
      if (this.confirm.buttons && this.confirm.buttons.length > 0) {
        return this.confirm.buttons;
      } else {
        return [
          { caption: this.translatedText("confirmText"), value: "ok" },
          { caption: this.translatedText("cancelText"), value: "cancel" },
        ];
      }
    },

    buttonClick(button) {
      this.$emit("close-confirm", { result: button.value });
    },
  },

  updated() {},
};
</script>

<style>
</style>